import { useEffect, useState } from 'react';
import api from '../lib/api';

// Iter 365 — Selector canónico Condición de Pago (CP-*) + Medio de Pago (MP-*).
// Solo ofrece condiciones VIGENTES del catálogo ERP; nunca texto libre.
// value: { condicion_codigo, medio_pago_codigo }
// onChange({ condicion_codigo, medio_pago_codigo, requiere_medio_pago, condicion })
export function CondicionMedioPagoSelect({ value, onChange, testIdPrefix = 'cmp' }) {
  const [condiciones, setCondiciones] = useState([]);
  const [medios, setMedios] = useState([]);

  useEffect(() => {
    api.get('/condiciones-pago-crud', { params: { solo_nuevas: true } })
      .then((r) => setCondiciones(r.data || [])).catch(() => setCondiciones([]));
    api.get('/medios-pago')
      .then((r) => setMedios((r.data || []).filter((m) => m.habilitado_erp !== false && m.activo !== false)))
      .catch(() => setMedios([]));
  }, []);

  const condSel = condiciones.find((c) => c.codigo === value?.condicion_codigo);
  const isTarjeta = condSel?.tipo === 'tarjeta';
  const requiereMedioPago = condSel?.tipo === 'contado' || isTarjeta;

  const emit = (condicion_codigo, medio_pago_codigo) => {
    const cond = condiciones.find((c) => c.codigo === condicion_codigo);
    const req = cond?.tipo === 'contado' || cond?.tipo === 'tarjeta';
    onChange({ condicion_codigo, medio_pago_codigo: req ? medio_pago_codigo : '', requiere_medio_pago: req, condicion: cond || null });
  };

  const cats = isTarjeta
    ? [{ key: 'tarjeta_credito', label: 'Tarjeta de Crédito' }]
    : [
        { key: 'transferencia_anticipo', label: 'Transferencia / Anticipo' },
        { key: 'rendicion', label: 'Rendición (Caja Chica)' },
        { key: 'otro', label: 'Otro' },
      ];

  return (
    <div className="border border-emerald-200 bg-emerald-50/40 rounded p-3 space-y-2" data-testid={`${testIdPrefix}-section`}>
      <p className="text-xs font-bold text-emerald-800">Condición de Pago <span className="text-red-600">*</span></p>
      <select
        value={value?.condicion_codigo || ''}
        onChange={(e) => emit(e.target.value, value?.medio_pago_codigo || '')}
        className={`w-full h-9 px-3 rounded-md border text-sm ${!value?.condicion_codigo ? 'border-red-400 bg-red-50/40' : 'border-emerald-300'}`}
        data-testid={`${testIdPrefix}-condicion-select`}
      >
        <option value="">Seleccione condición de pago...</option>
        {condiciones.map((c) => (
          <option key={c.codigo} value={c.codigo}>{c.nombre}{c.dias_plazo ? ` (${c.dias_plazo} días)` : ''}</option>
        ))}
      </select>
      {requiereMedioPago && (
        <div className="pt-1" data-testid={`${testIdPrefix}-medio-pago-container`}>
          <label className="block text-xs font-medium text-emerald-800 mb-1">
            Medio de Pago <span className="text-red-600">*</span>
            <span className="ml-1 text-[10px] font-normal text-slate-500">{isTarjeta ? '(sólo tarjetas)' : '(según medio real de pago)'}</span>
          </label>
          <select
            value={value?.medio_pago_codigo || ''}
            onChange={(e) => emit(value?.condicion_codigo || '', e.target.value)}
            className={`w-full h-9 px-3 rounded-md border text-sm ${!value?.medio_pago_codigo ? 'border-red-400 bg-red-50/40' : 'border-emerald-300'}`}
            data-testid={`${testIdPrefix}-medio-pago-select`}
          >
            <option value="">Seleccione medio de pago...</option>
            {cats.map((cat) => {
              const opts = medios.filter((m) => (m.categoria || 'otro') === cat.key);
              if (opts.length === 0) return null;
              return (
                <optgroup key={cat.key} label={cat.label}>
                  {opts.map((m) => <option key={m.codigo} value={m.codigo}>{m.nombre}</option>)}
                </optgroup>
              );
            })}
          </select>
        </div>
      )}
    </div>
  );
}
